// TODO rename to OpportunityState
// CoachDiag.Lookup_OpportunityState
export enum OpportunityStatus {
    NEW = 1, // in intervention
    POTENTIAL,
    ACTIVE,
    POTENTIALLY_CLOSING,
    CLOSED,
    INVALID,
}
